import { useEffect, useState } from "react";
import axios from "axios";

import { getAuthorizationToken } from "@/auth/tokenStore";

import { getCaseId, getClientId } from "../../Utils/helper";

import PendingTasks from "./Elements/PendingTasks";
import CasesTimeline from "./Elements/CasesTimeline";
import CaseCompletion from "./Elements/CaseCompletion";
import LeastAccess from "./Elements/LeastAccess";
import ExpireStatute from "./Elements/ExpireStatute";
import OpenCases from "./Elements/OpenCases";
import CasesRole from "./Elements/CasesRole";

const CaseDetails = () => {
  const origin = process.env.REACT_APP_BACKEND_URL;
  const caseId = getCaseId();
  const clientId = getClientId();
  const token = getAuthorizationToken();
  const [chats, setChats] = useState([]);
  const fetchHomeChats = async () => {
    try {
      const response = await axios.get(origin + "/api/home/case-detail/", {
        headers: {
          Authorization: token,
        },
        params: {
          client_id: clientId,
          case_id: caseId,
        },
      });
      setChats(response.data);
    } catch (error) {
      console.error(error);
      setChats([]);
    }
  };

  useEffect(() => {
    fetchHomeChats();
  }, []);

  // Note: there is no data in the backend for Case Completion and Open Cases Components
  return (
    <>
      <div className="content-right order-3 order-lg-2 w-100">
        <PendingTasks chats={chats} />

        <div className="d-flex flex-wrap case-completion-open-roles m-b-5" style={{ gap: "5px" }}>
          <CaseCompletion />

          <div
            className="case-roles column order-3 ps-0 bg-primary-2 pe-0"
            id="caseRolesPercentageNewUpdateFlexValue"
          >
            <CasesRole chats={chats} />
          </div>

          <div
            className="open-cases column order-2 pe-0 order-xl-3 order-xxl-3"
            id="caseRolePercentageCheckNewUpdate"
          >
            <OpenCases />
          </div>
        </div>

        <div className="row custom-gutter two-equal-tables" style={{ zIndex: "0" }}>
          <LeastAccess chats={chats} />
          <ExpireStatute chats={chats} />
        </div>
      </div>

      <div className="sidebar order-2 order-lg-3 m-t-5" style={{ zIndex: "0" }}>
        <CasesTimeline chats={chats} />
      </div>
    </>
  );
};

export default CaseDetails;
